import React, { Component } from 'react';
import { Track } from './Track';
import { Table, Header, Loader, Segment } from 'semantic-ui-react';

export default class NowPlaying extends Component {
    constructor(props) {
        super(props);

        this.updateTitle = this.props.updateTitle.bind(this);
    }

    onError(error){
        console.log(error)
    }

    render() {
        this.updateTitle(this.props.currentTrack, this.props.appName);

        let trackOptions = {
            addToPlaylist: false,
            sortable: false,
            skip: true
        };

        return (
            <Segment raised>
                <Header size="medium" className="now-playing">Now Playing</Header>
                { this.props.currentTrack ? (                   
                <Table compact basic unstackable className="now-playing">
                    <Table.Body>
                        <Track key={this.props.currentTrack.album_id + `-` + this.props.currentTrack.track_id} options={trackOptions} index={0} {...this.props.currentTrack}/>	
                    </Table.Body>
                </Table>
                ): (
                <Loader active />
                ) }
            </Segment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/NowPlaying.js